import {VERSION as CDK_VERSION} from '@angular/cdk';
import {VERSION as MAT_VERSION, MatNativeDateModule} from '@angular/material/core';
import { enableProdMode, importProvidersFrom } from '@angular/core';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app/routes';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AmazonUpdateService } from './app/services/amazon-data/amazon-info.service';
import { LogService, LogPublishersService, AuthService } from './app/services';
import { BookService } from './app/services/book.service';

if (environment.production) {
  enableProdMode();
}

/* eslint-disable no-console */
console.info('Angular CDK version', CDK_VERSION.full);
console.info('Angular Material version', MAT_VERSION.full);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule),
        provideRouter(routes),
        MatNativeDateModule,
        BookService,
        LogService,
        LogPublishersService,
        AuthService,
        AmazonUpdateService,
        provideAnimations(),
        importProvidersFrom(MatNativeDateModule),
        provideHttpClient(withInterceptorsFromDi())
    ]
})

